import React, { Component, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import Dropzone from 'react-dropzone';
import Alert from '@material-ui/lab/Alert';
import { isEmpty,isUndefined } from 'lodash';
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const baseStyle = {
    fontSize: '1.4rem',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px',
    borderWidth: 2,
    borderRadius: 5,
    borderColor: 'grey',
    borderStyle: 'dashed',
    backgroundColor: 'white',
    color: 'grey',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '150px',
};
const activeStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};
function StyledDropzone(props) {
    let messageLaddaFile=props.UpLoadfileMessage
    console.log(props,"asd")
    const style = useMemo(() => ({
        ...baseStyle,
        borderColor: props.error ? 'red' : 'grey'
    }), [
      props.error
    ]);
    const onDrop = (acceptedFiles) => {
    //  console.log(acceptedFiles);
      props.getFile(acceptedFiles)
    }
    //10MB
    let maxSize = isUndefined(props.isEsignering)?20485760:parseInt(props.isEsignering) === 0?20485760:10235760;
    
    return (
        <div className="text-center">
        <Dropzone onDrop={onDrop}
        accept="
                .pdf
                "
        minSize={0}
        maxSize={maxSize}
        >
          {({getRootProps, getInputProps, isDragActive,isDragAccept ,isDragReject,rejectedFiles,acceptedFiles}) => {
            const isFileTooLarge = rejectedFiles.length > 0 && rejectedFiles[0].size > maxSize;
              return (<div {...getRootProps({style})}>
              <input {...getInputProps()} />
              {acceptedFiles.length === 0 && !isDragReject && !isDragAccept && !isDragActive && messageLaddaFile}
              {isDragActive && "Drop it like it's hot!"}
              {rejectedFiles.length ===1 && (
                  <Alert severity="error"><IntlMessages id="Warning.file.not.Accepted"/></Alert>
                )}
              {acceptedFiles.length === 1 && (
                  <Alert severity="info"><IntlMessages id="Warning.file.Accepted"/></Alert>
                )}              
              {acceptedFiles.length > 1 && (
                  <Alert severity="Error"><IntlMessages id="Warning.Max.Onefile"/></Alert>
                )}              
              {isFileTooLarge && (
                  <Alert severity="warning"><IntlMessages id="UpLoad.file.Message.TooLarge"/></Alert>
               )}
             {acceptedFiles.length === 1 && acceptedFiles.map(acceptedFile => {
                  return <Alert severity="success">{acceptedFile.name}</Alert>
             })}
            </div>
            )
            }
        }
        </Dropzone>
      </div>
    )
}

class ImportExcelFile extends Component {
    getFile=(file)=>{
        this.props.onchangeHanelEvent("file",file)
    }
    render() {
      const UpLoadfileMessage = this.props.intl.formatMessage({ id: 'UpLoad.file.Message.Pdf' });
        return (
            <div>
                <StyledDropzone error={this.props.error} getFile={this.getFile} file={this.props.Value} UpLoadfileMessage={UpLoadfileMessage}
                isEsignering={isUndefined(this.props.isEsignering)?0:this.props.isEsignering} 
                />
            </div>
        )
    }
}
export default injectIntl(ImportExcelFile);